<template>
	<div class="container">
		<h3>Dashboard</h3>
		<hr />
		<BRow style="row-gap: 1rem">
			<BCol v-if="isCleaner" lg="6">
				<BCard class="white" body-class="p-4">
					<div class="d-flex justify-content-between align-items-center gap flex-wrap">
						<div class="flex-grow-1">
							<h3 class="text-primary">
								Purchase Absolute Domestics Staff Company T-shirts
							</h3>
							<p>You can now purchase new Absolute Domestics company t-shirts</p>
						</div>
						<div class="d-flex align-items-center gap-lg">
							<BLink
								tag="button"
								class="btn btn-primary text-truncate"
								href="https://abdom.cimcgroup.com.au/"
								target="_blank">
								Go to Shop
								<BIcon icon="chevron-right" aria-hidden="true"></BIcon>
							</BLink>
							<div
								class="flex-shrink-1 border border-primary bg-white overflow-hidden rounded d-inline-flex flex-column p-2">
								<img src="/assets/img/shirts-1.png" width="200px"
									class="img-fluid" />
								<img src="/assets/img/shirts-2.png" width="200px"
									class="img-fluid" />
							</div>
						</div>
					</div>
				</BCard>
			</BCol>
			<BCol v-if="isClient && user.can_setup_credit_card" lg="6">
				<BCard class="primary" body-class="p-4">
					<h3>Welcome to the <span class="text-primary">MyAbdom</span> Portal</h3>
					<p>Start by updating your credit card details to convert your bookings to credit card payment.</p>
					<p>
						Your cleaner will request payment for each service and you will be notified via email. 24 hours
						later, the payment will automatically be processed against your nominated credit card unless we
						hear from you.
					</p>
					<router-link to="/setup-credit-card" class="btn btn-primary d-inline-flex align-items-center">
						<BIcon icon="credit-card" class="mr-2"></BIcon>
						Setup Credit Card Payments
					</router-link>
				</BCard>
			</BCol>
			<BCol v-if="showAbnForm" lg="6">
				<BCol>
					<abn-form :user-id="user.id" />
				</BCol>
			</BCol>
			<BCol v-if="isCleaner" lg="12">
				<vaccination-status></vaccination-status>
			</BCol>
			<BCol v-if="isCleaner" lg="6">
				<div class="card v-step-1 v-step-2">
					<div class="card-body">
						<div class="row align-items-center">
							<div class="col">
								<h6 class="card-title text-uppercase text-muted mb-2">
									Overdue Absolute Domestics Fees
								</h6>
								<span class="h2 mb-0"> ${{ overdue_fees.absolute_domestics_total }} </span>
								<span class="badge badge-danger mt-n1"> Due </span>
							</div>
							<div class="col-auto">
								<span class="h2 fe fe-dollar-sign text-muted mb-0"></span>
							</div>
						</div>
						<div class="clearfix mt-2"></div>
						<span class="text-muted">
							You have <strong>{{ overdueAbsoluteDomesticsFees.total }}</strong> fees due.
							<span v-if="overdueAbsoluteDomesticsFees.total">
								Please click the button below to pay them.
							</span>
						</span>
						<div class="table-responsive mt-2">
							<table class="table table-sm table-nowrap card-table">
								<tbody>
									<tr v-for="fee in overdueAbsoluteDomesticsFees.fees" :key="fee.id">
										<td>{{ fee.title }}</td>
										<td>${{ fee.amount }}</td>
									</tr>
									<tr v-if="overdueAbsoluteDomesticsFees.length > 3">
										<td>
											And <strong>{{ overdueAbsoluteDomesticsFees.length - 3 }}</strong>
											more...
										</td>
										<td></td>
									</tr>
								</tbody>
							</table>
						</div>
						<div v-if="overdueAbsoluteDomesticsFees.length" class="row">
							<div class="col">
								<router-link class="btn btn-sm btn-primary float-right" to="/fees">
									Pay Fees
								</router-link>
							</div>
						</div>
					</div>
				</div>
			</BCol>
			<BCol v-if="isCleaner && user.accepts_invoice_jobs" lg="6">
				<div class="card v-step-1 v-step-2">
					<div class="card-body">
						<div class="row align-items-center">
							<div class="col">
								<h6 class="card-title text-uppercase text-muted mb-2">
									Pending Clean Homes Invoices
								</h6>
								<span class="h2 mb-0"> ${{ overdue_fees.clean_homes_total }} </span>
								<span class="badge badge-danger mt-n1"> Due </span>
							</div>
							<div class="col-auto">
								<span class="h2 fe fe-dollar-sign text-muted mb-0"></span>
							</div>
						</div>
						<div v-if="overdue_fees.clean_homes_total" class="row">
							<div class="col">
								<router-link class="btn btn-sm btn-primary float-right" to="/clean-homes-fees">
									Submit Invoices
								</router-link>
							</div>
						</div>
					</div>
				</div>
			</BCol>
			<BCol v-if="isCleaner" lg="6">
				<div class="card">
					<div class="card-body">
						<h4 class="card-title">
							Payment Summaries
						</h4>
						<small class="text-muted">Wed, June 10th 2020 8:30 AM</small>
						<p>
							Payments summaries for this financial year will be available to download from MyAbdom on
							July 1st. Visit Account >
							<router-link :to="'/payment-summaries'">
								Payment Summaries
							</router-link>
							to download your summary.
						</p>
					</div>
				</div>
				<div class="card v-step-0">
					<div class="card-body">
						<h4 class="card-title">
							Welcome to MyAbdom
						</h4>
						<small class="text-muted">Tue, Oct 1st 2019 8:30 AM</small>
						<p>
							Welcome to MyAbdom where we're making it easier for you to do business with us! To access
							the fees section, please visit the fees link in the navigation.
						</p>
					</div>
				</div>
			</BCol>
			<BCol v-if="isClient" lg="6">
				<div class="d-flex justify-content-between align-items-center mb-2">
					<h5 class="mb-0">
						My Bookings
					</h5>
					<router-link to="/bookings">
						<h5 class="text-muted mb-0">
							View All Bookings
							<BIcon icon="chevron-right" aria-hidden="true"></BIcon>
						</h5>
					</router-link>
				</div>
				<div class="d-flex flex-column gap-y mb-3">
					<booking v-for="booking in bookings" :key="booking.id"
						:booking="booking"></booking>
				</div>
				<div style="cursor: pointer" @click="navigateToBookingForm">
					<BCard
						class="mt-2"
						:class="{
							primary: bookings.length > 0 && !user.can_setup_credit_card,
						}">
						<h5 class="mb-0 text-primary d-flex align-items-center justify-content-center">
							Create a Booking
							<BIcon icon="plus" font-scale="1.5"
								aria-hidden="true"></BIcon>
						</h5>
					</BCard>
				</div>
			</BCol>
			<BCol lg="6">
				<div class="mb-2">
					<h5 class="mb-0">
						Notifications
					</h5>
				</div>
				<BCard body-class="pt-2 px-2 pb-0">
					<notifications-list></notifications-list>
				</BCard>
				<div
					v-if="notifications.meta.total > notifications.meta.per_page"
					class="mt-2 d-flex flex-1 justify-content-end">
					<BPagination
						:model-value="notifications.meta.current_page"
						:total-rows="notifications.meta.total"
						:per-page="notifications.meta.per_page"
						@update:model-value="fetchNotifications">
					</BPagination>
				</div>
			</BCol>
		</BRow>
		<onboarding-tour v-if="isCleaner && !user.onboarding_status.dashboard"></onboarding-tour>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import OnboardingTour from './OnboardingTour.vue';
	import NotificationsList from '@js/components/NotificationsList.vue';
	import VaccinationStatus from '@js/components/my/account/VaccinationStatus.vue';
	import Booking from '@js/components/my/bookings/Booking.vue';
	import ABNForm from './ABNForm.vue';

	export default {
		components: {
			VaccinationStatus,
			NotificationsList,
			OnboardingTour,
			Booking,
			'abn-form': ABNForm,
		},
		data() {
			return {
				overdue_fees: {
					absolute_domestics: [],
					clean_homes: [],
					clean_homes_total: null,
					absolute_domestics_total: null,
				},
				bookings: [],
			};
		},
		computed: {
			...mapGetters({
				user: 'auth/user',
				notifications: 'notifications/getNotifications',
			}),
			overdueAbsoluteDomesticsFees() {
				return this.overdue_fees.absolute_domestics;
			},
			showAbnForm() {
				if (!this.isCleaner) {
					return false;
				}

				if (this.user.accepts_invoice_jobs && !this.user.abn) {
					return true;
				}

				return !(this.user.country !== 'AU' || parseInt(this.user.abn) > 1);
			},
		},
		created() {
			this.fetchNotifications();

			if (this.isClient) {
				this.fetchBookings();
			}

			if (this.isCleaner) {
				this.fetchOverdueFees();
			}
		},
		methods: {
			fetchBookings() {
				this.$axios
					.get('/api/client/bookings', {
						params: {
							status: 'Active',
						},
					})
					.then((response) => {
						this.bookings = response.data.data;
					});
			},
			fetchOverdueFees() {
				this.$axios
					.get('/api/cleaner/fees', {
						params: {
							company: 'Absolute Domestics',
							per_page: 3,
						},
					})
					.then((response) => {
						this.overdue_fees.absolute_domestics_total = response.data.total_outstanding;
						this.overdue_fees.absolute_domestics = response.data.data;
					})
					.catch(() => {
						toastr.error('An error occurred while fetching overdue fees');
					});
				this.$axios
					.get('/api/cleaner/fees', {
						params: {
							company: 'Clean Homes',
						},
					})
					.then((response) => {
						this.overdue_fees.clean_homes_total = response.data.total_outstanding;
					})
					.catch(() => {
						toastr.error('An error occurred while fetching overdue fees');
					});
			},
			fetchNotifications(page) {
				this.$store.dispatch('notifications/fetchNotifications', {
					page: page,
					per_page: 5,
				});
			},
			navigateToBookingForm() {
				const url =
					this.user.country === 'AU'
						? 'https://book.absolutedomestics.com.au'
						: 'https://book.absolutedomestics.co.nz';

				window.open(url, '_blank');
			},
		},
	};
</script>
